<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="87.507"
    height="40.616"
    viewBox="0 0 87.507 40.616"
  >
    <g id="noon" transform="translate(-99.8 -314.2)">
      <rect
        id="Rectangle_1"
        data-name="Rectangle 1"
        width="87.507"
        height="40.616"
        transform="translate(99.8 314.2)"
        fill="#fff"
      />
      <g
        id="Group_1"
        data-name="Group 1"
        transform="translate(104.315 318.425)"
      >
        <path
          id="noonWaaw"
          d="M657.486,386.385v2.46a2.375,2.375,0,0,1-2.362,2.372H643.065l-.087-2.471a4.09,4.09,0,0,0-8.178.142v.055a4.1,4.1,0,0,0,4.089,4.089h2.372a3.583,3.583,0,0,1-3.564,3.214v1.815a5.392,5.392,0,0,0,5.379-5.029h12.037a4.176,4.176,0,0,0,4.176-4.176V386.4h-1.8Zm-16.607,4.821H638.9a2.272,2.272,0,0,1-2.274-2.274v-.055a2.275,2.275,0,0,1,4.548-.077l.088,2.405Z"
          transform="translate(-580.824 -381.306)"
          fill="#4a4a4a"
        />
        <path
          id="semicircle2"
          d="M517.617,399.3H515.8v3.892a3.444,3.444,0,1,1-6.888,0V399.3H507.1v3.892a5.259,5.259,0,1,0,10.517,0Z"
          transform="translate(-467.086 -394.221)"
          fill="#4a4a4a"
        />
        <circle
          id="nukhtaOfNoon2"
          cx="0.973"
          cy="0.973"
          r="0.973"
          transform="translate(44.101 1.388) rotate(-13.286)"
          fill="#4a4a4a"
        />
        <circle
          id="nukhtaOfNoon"
          cx="0.973"
          cy="0.973"
          r="0.973"
          transform="translate(73.425 1.143)"
          fill="#4a4a4a"
        />
        <path
          id="semicircle"
          d="M166.956,385.2l-2.689,4.614a10.529,10.529,0,0,1,3.772,8,10.942,10.942,0,0,1-10.944,10.944,11.1,11.1,0,0,1-11.13-10.944,9.826,9.826,0,0,1,.241-2.285l-5.106,2.985a15.646,15.646,0,0,0,15.995,15.317,16.014,16.014,0,0,0,9.861-28.633Z"
          transform="translate(-141.1 -381.663)"
          fill="#4a4a4a"
        />
        <path
          id="island"
          d="M245.411,358.318l2.711-4.657s-2.34-1.345-6.811-.579L237.9,359.04C237.889,359.051,240.753,357.159,245.411,358.318Z"
          transform="translate(-227.317 -352.846)"
          fill="#4a4a4a"
        />
        <path
          id="o"
          d="M605.286,534.4a3.742,3.742,0,1,0,3.586,3.739A3.665,3.665,0,0,0,605.286,534.4Zm0,5.685a1.966,1.966,0,1,1,1.782-1.957A1.875,1.875,0,0,1,605.286,540.085Z"
          transform="translate(-551.343 -514.551)"
          fill="#4a4a4a"
        />
        <path
          id="o-2"
          data-name="o"
          d="M702.686,534.4a3.742,3.742,0,1,0,3.586,3.739A3.665,3.665,0,0,0,702.686,534.4Zm0,5.685a1.966,1.966,0,1,1,1.782-1.957A1.875,1.875,0,0,1,702.686,540.085Z"
          transform="translate(-638.095 -514.551)"
          fill="#4a4a4a"
        />
        <path
          id="n"
          d="M803,534.394a3.216,3.216,0,0,0-2.121.732l-.175-.558h-1.4v7.139h1.793v-4c0-1.52,1.629-1.531,1.629-1.531,1.235,0,1.29,1.323,1.29,1.323v4.22h1.76v-4.57A2.706,2.706,0,0,0,803,534.394Z"
          transform="translate(-727.34 -514.545)"
          fill="#4a4a4a"
        />
        <path
          id="n-2"
          data-name="n"
          d="M510.8,534.394a3.216,3.216,0,0,0-2.121.732l-.175-.558h-1.4v7.139h1.793v-4c0-1.52,1.629-1.531,1.629-1.531,1.235,0,1.29,1.323,1.29,1.323v4.22h1.76v-4.57A2.711,2.711,0,0,0,510.8,534.394Z"
          transform="translate(-467.086 -514.545)"
          fill="#4a4a4a"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconNoon",
};
</script>

<style>
.st0 {
  fill: #fff;
}
.st1 {
  fill: #4a4a4a;
}
</style>